<template>
  <div id="app">
    <router-view/>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="less">
  @import "assets/style/Global.less";
  @import "assets/plugin/ztree/css/frosStyle/frosStyle.css";
  /*@import "assets/plugin/ztree/css/zTreeStyle/zTreeStyle.css";*/
  /*@import "assets/plugin/ztree/css/bootstrapStyle/bootstrapStyle.css";*/
</style>



// WEBPACK FOOTER //
// src/App.vue